import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";
import Associates from "./Associates";

const ApplyNow = () => {
    const navigate = useNavigate();

   

    return (
        <>
            <div className="other-pages-main-section apply-page-fin">
                <h2 className="other-pages-title">Apply Now</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/apply-loan-online")} style={{ cursor: "pointer" }}>Apply now</span>
                </p>
            </div>
            <Associates />
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default ApplyNow;
